import { api } from '@/lib/api'
import { ticketPathSegmentFromListItem } from '@/lib/ticket-display'
import type { TicketListItem } from '@/types/api'

function firstOtherTicket(
  tickets: TicketListItem[],
  currentTicketId: string,
): TicketListItem | null {
  const filtered = tickets.filter((t) => {
    const seg = ticketPathSegmentFromListItem(t)
    return t.id !== currentTicketId && seg !== currentTicketId
  })
  return filtered[0] ?? null
}

/** Как `getNextTicket` в classic — для «Ответить и перейти к следующему». */
export async function fetchNextUnassignedTicketWide(
  projectId: string,
  currentTicketId: string,
): Promise<TicketListItem | null> {
  const res = await api.tickets({
    status: 'new,open,in_progress,pending',
    project_id: projectId,
    page_size: 100,
    assigned: false,
    exclude_ai_assigned: true,
    include_counts: false,
  })
  return firstOtherTicket(res.tickets ?? [], currentTicketId)
}

/** Как `getNextOpenTicket` в classic — горячая клавиша Ctrl+Alt+↓ и кнопка «К следующему». */
export async function fetchNextUnassignedOpenTicket(
  projectId: string,
  currentTicketId: string,
): Promise<TicketListItem | null> {
  const res = await api.tickets({
    status: 'open,in_progress',
    project_id: projectId,
    page_size: 100,
    assigned: false,
    exclude_ai_assigned: true,
    include_counts: false,
  })
  return firstOtherTicket(res.tickets ?? [], currentTicketId)
}
